export const AddressInputFormKeysShared = {
  CITY: 'city',
  POSTAL_CODE: 'postalCode',
} as const

export const AddressInputFormKeys = {
  ...AddressInputFormKeysShared,
  ADDRESS_1: 'address1',
  ADDRESS_2: 'address2',
} as const

export const AddressInputFormKeysV2 = {
  ...AddressInputFormKeysShared,
  ADDRESS_LINE_1: 'addressLine1',
  ADDRESS_LINE_2: 'addressLine2',
} as const

export const AddressSelectFormKeys = {
  COUNTRY_CODE: 'countryCode',
} as const

export const AddressFormKeys = {
  ...AddressInputFormKeys,
  ...AddressSelectFormKeys,
} as const

export const AddressFormKeysV2 = {
  ...AddressInputFormKeysV2,
  ...AddressSelectFormKeys,
} as const

export const AddressFormKeyList = Object.values(AddressFormKeys)

export const AddressFormKeyListV2 = Object.values(AddressFormKeysV2)
